import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faSearch,
  faAngleDown,
  faAngleUp,
  faPlay,
  faCircle,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

library.add(faSearch);
library.add(faBars);
library.add(faAngleDown);
library.add(faAngleUp);
library.add(faPlay);
library.add(faCircle);
library.add(faCheck);
